<template>
  <div v-if="shouldShowBanner" class="ai-reason-bnr">
    <button class="ai-reason-bnr-btn" @click="openAiReasonDialog">
      <img src="/static/renew2_img/ai_reason_bnr.png" alt="文章作成が苦手でも大丈夫！お困りですか？AIの文章作成をつかう"
        class="ai-reason-bnr-btn__img">
    </button>
    <button @click="closeBtn" class="ai-reason-bnr-close-btn">×</button>
  </div>
</template>

<style lang="scss" scoped>
.ai-reason-bnr {

  button {
    background: none;
    cursor: pointer;
  }

  text-align: center;
  position: fixed;
  bottom: 0;
  left: calc(50% - 175px);
  width: 350px;
  height: auto;
  text-align: center;
  z-index: 100;

  .ai-reason-bnr-btn {
    &:hover {
      opacity: 1;
    }

    &__img {
      box-shadow: 0px 0px 15px -5px #777777;
      border-radius: 10px;
    }
  }

  .ai-reason-bnr-close-btn {
    position: absolute;
    display: inline-block;
    top: -10px;
    right: 0;
    width: 25px;
    height: 25px;
    background: #DFDFDF;
    border: none;
    border-radius: 50%;
    font-size: 19px;
    text-align: center;
    cursor: pointer;
    color: #E3165C;
  }
}
</style>

<script>
export default {
  data () {
    return {
      // 70%の確率で表示するためのランダム値（初期化時に決定）
      showRandomly: Math.random() < 0.7
    }
  },
  computed: {
    shouldShowBanner () {
      const currentPath = this.$route.path

      // YagiPrimeユーザーには表示しない
      if (this.$globalVar.isYagiPrime) {
        return false
      }

      // /format/{format_id}/edit/reasonパターンをチェック
      // 正規表現で /format/文字列/edit/reason にマッチするかチェック
      const reasonPagePattern = /^\/format\/[^/]+\/edit\/reason$/

      // パスが一致し、かつランダムで表示対象の場合のみ表示
      return reasonPagePattern.test(currentPath) && this.showRandomly
    }
  },
  methods: {
    closeBtn () {
      const element = document.querySelector('.ai-reason-bnr')
      element.style.display = 'none'
    },
    openAiReasonDialog () {
      // ReasonCard.vueコンポーネントのAI文章作成ポップアップを表示するイベントを発火
      this.$eventHub.$emit('open-ai-reason-dialog')
    }
  }
}
</script>
